var map = {
	"./A_ped.png": 2205,
	"./B_ped.png": 6538,
	"./C_ped.png": 5991,
	"./D_ped.png": 5436,
	"./E_ped.png": 7505,
	"./F_ped.png": 6462,
	"./G_ped.png": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9505;